module.exports = __webpack_public_path__ + "static/media/Employee.011f69d8.svg";